module.exports = __webpack_public_path__ + "img/1006877170.4c5df72a.png";